import { render, staticRenderFns } from "./PublicFooter.vue?vue&type=template&id=4aa1fce0&scoped=true&"
import script from "./PublicFooter.vue?vue&type=script&lang=js&"
export * from "./PublicFooter.vue?vue&type=script&lang=js&"
import style0 from "./PublicFooter.vue?vue&type=style&index=0&id=4aa1fce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa1fce0",
  null
  
)

export default component.exports